// extracted by mini-css-extract-plugin
export default {"floatycircle":"floaty-module--floatycircle--1HxvG","awslogo":"floaty-module--awslogo--isqgg","cov1":"floaty-module--cov1--OsvU2","cov2":"floaty-module--cov2--1w9jm"};